import { Suspense } from 'react';
import { useRoutes } from 'react-router-dom';
import { LoggedInRoutesConfig, LoggedOutRoutesConfig } from './routes-config';
import { useUserProfile } from '../hooks/useUserProfile';
import { RouteErrorBoundary } from './route-error-boundary';
import { LoadingSpinner } from '../components/loading-spinner/loading-spinner';

export const AppRouter = () => {
  const { isLoggedIn, userProfileLoading } = useUserProfile();

  const routeConfig = isLoggedIn ? LoggedInRoutesConfig : LoggedOutRoutesConfig;
  const routes = useRoutes(routeConfig);

  if (userProfileLoading) {
    return <LoadingSpinner />;
  }

  return (
    <RouteErrorBoundary>
      <Suspense fallback={<LoadingSpinner />}>{routes}</Suspense>
    </RouteErrorBoundary>
  );
};
